module.exports = __webpack_public_path__ + "img/business_in_transition_details.598505e1.svg";